<template>
  <div class="criterio-input-categories">
    <v-flex xs12>
      <categories-search-modal
        solo
        :selectedItems.sync="categories"
        is-segmentation
        itemType="categoria_produto"
        :disable-save="disableSave"
        :tooltip-primary-button="tooltipPrimaryButton"
        :tooltip-primary-button-message="tooltipPrimaryButtonMessage"
        @input="input"
      />
    </v-flex>
  </div>
</template>

<script>
import CategoriesSearchModal from '@/components/categories-search-modal/CategoriesSearchModal.vue'

export default {
  components: {
    CategoriesSearchModal,
  },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Array, Number],
      default: () => {
        return {}
      },
    },
    values: Array,
    disableSave: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    categories: [],
  }),

  computed: {
    tooltipPrimaryButton() {
      return this.disableSave
    },
    tooltipPrimaryButtonMessage() {
      return this.disableSave ? 'Não é possível alterar um segmento estático' : ''
    },
  },

  mounted() {
    this.categories = this.initialValue || []
    this.validate()
  },

  methods: {
    input(value) {
      const categoriesToSave = this.categories.map((categorie) => {
        return categorie.id
      })
      this.$emit('input', { currentValue: categoriesToSave, currentChildren: this.values[0], currentIndex: this.currentIndex })

      this.validate()
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.categories && this.categories.length)
    },
  },
}
</script>

<style lang="scss">
.criterio-input-categories {
  .v-input__control {
    padding: 5px 0 !important;
  }
}
</style>
